import { useLang } from "@/i18n/LanguageContext";
import { Reveal, Eyebrow } from "@/components/Reveal";

const STEPS = ["a", "b", "c", "d"];

const Process = () => {
  const { t } = useLang();

  return (
    <section className="relative py-16 md:py-32 px-6 md:px-12 bg-background">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="max-w-2xl mb-16">
            <Eyebrow>{t("process.badge")}</Eyebrow>
            <h2 className="mt-6 font-serif text-4xl md:text-5xl text-foreground leading-tight">
              {t("process.title")}
            </h2>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border border border-border">
          {STEPS.map((key, i) => (
            <Reveal key={key} delay={i * 0.1}>
              <div className="group h-full bg-card hover:bg-muted transition-colors duration-500 p-8 relative overflow-hidden">
                <span className="block font-serif text-6xl text-gold/15 group-hover:text-gold/30 transition-colors duration-500 leading-none">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-5 font-serif text-2xl text-gold">{t(`process.steps.${key}.title`)}</h3>
                <p className="mt-3 text-sm text-muted-foreground font-sans leading-relaxed">
                  {t(`process.steps.${key}.desc`)}
                </p>
                <span className="absolute bottom-0 left-0 h-[2px] w-0 group-hover:w-full bg-gold transition-all duration-700" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
